export const comments_5187251 = {"data":{"data":[],"links":{}}}